import React from 'react';
import { Typography } from 'antd';

const { Title, Text } = Typography;

interface SelectedViewBadgeProps {
  selectedView?: string | null;
  pageName?: string;
}

const SelectedViewBadge: React.FC<SelectedViewBadgeProps> = ({ selectedView, pageName }) => {
  if (!selectedView) {
    return null;
  }

  const formattedSelectedView =
    selectedView.charAt(0).toUpperCase() + selectedView.slice(1);

  return (
    <Title
      level={5}
      style={{
        padding: '2px 20px 0px 20px',
        flexShrink: 0,
        fontSize: '14px',
      }}
    >
      <Text style={{ fontWeight: 'bold' }}>{formattedSelectedView}</Text>
      <Text>{` - ${pageName}`}</Text>
    </Title>
  );
};

export default SelectedViewBadge;